import { useEffect, type ReactNode } from 'react';
import { Toast } from '../components/feedback/States';
import { useGame } from './gameContext';
import { isLiveMode } from './gameSocket';
import { MockGameProvider } from './mockGameStore';
import { ServerGameProvider } from './serverGameStore';
import { playSound } from './soundManager';

function GameErrorToast() {
  const { lastError, clearError, runtimeMode } = useGame();
  useEffect(() => {
    if (lastError && runtimeMode === 'server') playSound('error');
  }, [lastError, runtimeMode]);
  if (!lastError || runtimeMode !== 'server') return null;

  const [title, ...rest] = lastError.split(' — ');
  const detail = rest.length ? rest.join(' — ') : lastError;

  return (
    <div className="fixed bottom-24 md:bottom-8 left-1/2 -translate-x-1/2 z-[100] max-w-md w-full px-4">
      <button type="button" onClick={clearError} className="w-full text-left">
        <Toast title={title || 'Server error'} message={detail} variant="error" />
      </button>
    </div>
  );
}

function LiveModeShell({ children }: { children: ReactNode }) {
  return (
    <ServerGameProvider>
      {children}
      <GameErrorToast />
    </ServerGameProvider>
  );
}

export function RuntimeGameProvider({ children }: { children: ReactNode }) {
  if (isLiveMode()) {
    return <LiveModeShell>{children}</LiveModeShell>;
  }
  return <MockGameProvider>{children}</MockGameProvider>;
}

export function getRuntimeModeLabel(): 'mock' | 'live' {
  return isLiveMode() ? 'live' : 'mock';
}
